import { SandboxClinicalData } from '@chiroup/core/types/SandboxClinicalData.type';
import { createContext, useContext } from 'react';

/** Only the public demo supplies this context; normal EHR queries stay live. */
export const SandboxClinicalDataContext = createContext<SandboxClinicalData | null>(null);

export const useSandboxClinicalData = () => useContext(SandboxClinicalDataContext);
